module.exports = "/_next/static/images/2093b58be59ab2537cf393cbc33ad2f0-nuconta-inclined-device@1x.png";